module.exports = __webpack_public_path__ + "img/reward-2.f3ffef3b.png";